<template>
  <NuxtImg v-bind="$attrs" :src="props.src" :format="format" />
</template>

<script setup lang="ts">
const props = defineProps<{
  src: string
}>()

const format = computed(() => {
  if ((props.src || '').match(/\.(png|gif|svg)$/i)) {
    return 'png'
  }

  return 'jpeg,png'
})
</script>
